import { JSX, useCallback, useEffect, useState } from "react";

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import { FormField } from "./FormTypes";

export type SelectProps = {
	name?: string;
	label: string;
	field: FormField<string>;
	options: Array<[string, string]>;
};

function Select(props: SelectProps): JSX.Element {
	const [value, setValue] = useState(props.field.value);
	const [error, setError] = useState(props.field.error);

	useEffect(() => {
		if (props.field.value !== value) {
			setValue(props.field.value);
		}
	}, [props.field.value]);

	useEffect(() => {
		if (props.field.error !== error) {
			setError(props.field.error);
		}
	}, [props.field.error]);

	const onChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>): void => {
			props.field.value = event.target.value;
			props.field.error = false;

			setValue(props.field.value);
			setError(props.field.error);
		},
		[props.field]
	);

	return (
		<TextField
			name={props.name}
			label={props.label}
			value={value}
			error={error}
			onChange={onChange}
			InputLabelProps={{ shrink: true }}
			variant="standard"
			fullWidth
			select
			required={props.field.required}>
			{props.options.map(option => (
				<MenuItem key={option[0]} value={option[0]}>
					{option[1]}
				</MenuItem>
			))}
		</TextField>
	);
}

export default Select;
